import { getSessionDisplayStatus } from "../../../utils/clientSessionUtils";
import s from "./clientApp.module.css";

const TONE_CLASS = {
  neutral: s.badgeNeutral,
  success: s.badgeSuccess,
  danger: s.badgeDanger,
  warn: s.badgeWarn,
  poll: s.badgePoll,
};

const KIND_ICON = {
  scheduled: "○",
  poll_pending: "!",
  confirmed_yes: "✓",
  confirmed_no: "✕",
  attended: "✓",
  missed: "✕",
  cancelled: "⚠",
};

export default function SessionStatusBadge({ appointment, pollRow, large = false }) {
  const status = getSessionDisplayStatus(appointment, pollRow);
  const cls = `${large ? s.badgeLarge : s.badge} ${TONE_CLASS[status.tone] || s.badgeNeutral}`;

  return (
    <span className={cls}>
      <span className={s.badgeIcon}>{KIND_ICON[status.kind] || "○"}</span>
      {status.label}
    </span>
  );
}
